import React, { useMemo, useState } from 'react';
// import { sortBy } from 'lodash';
import styled from 'styled-components';

import turnSelectors, { turnManualSelectors } from 'features/turn/services/selectors';
// import { IStaffTurnItem } from '../TurnTable/TurnStaffTopRow';
// import Logo from 'assets/big-logo.svg';
import Text from 'components/Text';
import { StaffTurn, StaffTurnManager } from '../StaffTurns/Staff';
// import { getStaffNextTurn } from '../StaffTurns/helpers';
import useGetListServiceCode from 'features/turn/services/hooks/useGetListServiceCode';
import colorTheme from 'constants/color';
import { useAppDispatch } from 'store/hooks';
import turnActions, { turnManualAPIActions } from 'features/turn/services/actions';
import Box from 'components/Box';
import Button from 'components/Button';
import ConfigServiceCode, { useConfigServiceCodeRef } from './ConfigServiceCodeModal';
import { Funnel, MoveUp, Settings } from 'lucide-react';
import TurnServiceItem from '../TurnFooter/TurnServices/ServiceItem';
import { ITurnServiceItem } from 'features/turn/services/types/service';
import { ADD_WORKING_TURN, TURN_ITEM_STATUS } from 'features/turn/services/constants';
import TurnActions from '../TurnFooter/Actions';
import { IStaffAvailableItem } from 'services/shop/types/staff';

const StaffFilterTurn = () => {
  const { listServiceCode } = useGetListServiceCode();
  // const _mappingStaffs = turnSelectors.mappingStaffsByService();
  const availableStaffByService = turnSelectors.availableStaffByService();
  const inActiveTurnStaffs = turnManualSelectors.inActiveTurnStaffs();
  // const staffNextTurn = useMemo(() => getStaffNextTurn(_mappingStaffs), [_mappingStaffs]);
  const [selectedServiceCode, setSelectedServiceCode] = useState<string>('');
  const dispatch = useAppDispatch();
  const configServiceCodeRef = useConfigServiceCodeRef();
  const [open, setOpen] = useState(false);
  const fullTurnData = turnManualSelectors.fullTurnDataServices();
  const halfTurnData = turnManualSelectors.halfTurnDataServices();
  const noTurnData = turnManualSelectors.noTurnDataServices();
  const removeTurnManual = () => dispatch(turnManualAPIActions.removeTurnManual());
  const [filterStaff, setFilterStaff] = useState<IStaffAvailableItem | undefined>();
  const activeTurnManual = turnManualSelectors.activeTurnManual();
  // const sortByClockIn = useMemo(() => {
  //   const staffs = sortBy(_mappingStaffs, 'indexClockIn');
  //   return staffs;
  // }, [_mappingStaffs]);

//   const mappingStaffs = useMemo(() => {
//   return sortBy(
//     sortByClockIn,
//     staff => Math.floor(staff.totalTurn)
//   );
// }, [sortByClockIn]);



  // const staffs: IStaffTurnItem[] = useMemo(() => {
  //   return sortBy(mappingStaffs, (o) => o.staffId !== staffNextTurn?.staffId);
  // }, [mappingStaffs, staffNextTurn]);

  const staffs: IStaffAvailableItem[] = useMemo(() => {
    return availableStaffByService?.filter(o => o.statusWorking !== 'BUSY') ?? [];
  }, [availableStaffByService]);
  
  const ListOptionServiceCode = useMemo(() => {
    return [
      {
        label: 'All',
        value: '',
      },
      ...(listServiceCode?.filter((item) => item.code !== null)
        ?.map((o) => ({
        label: o?.code?.replaceAll('_', '-'),
        value: o?.code,
      })) ?? []),
    ];
  }, [listServiceCode]);

  const handleClickFilterItem = (value: string) => {
    if (selectedServiceCode === value || value === '') {
      setSelectedServiceCode('');
      dispatch(turnActions.getAvailableStaffByService.fetch());
      return;
    }

    setSelectedServiceCode(value);
    dispatch(turnActions.getAvailableStaffByService.fetch(value));
  };

  const onChooseService = (o: ITurnServiceItem) => {
    if (o.isClear) {
      removeTurnManual();
      setTimeout(() => {
        dispatch(turnActions.getAvailableStaffByService.fetch(selectedServiceCode || undefined));
      }, 500);
      return;
    }
    if (o.status === TURN_ITEM_STATUS.IN_PROGRESS) {
      const staffId = filterStaff?.staffId ?? staffs[0]?.staffId;

      if (!staffId) return;

      dispatch(
        turnManualAPIActions.handleWorkingTurn({
          staffId,
          selectedServiceCode,
        })
      );

      if (filterStaff) {
        setFilterStaff(undefined);
      }

      return;
    }

    dispatch(turnManualAPIActions.handleTurnWithService(o));
    if (activeTurnManual) {
      setTimeout(() => {
        dispatch(turnActions.getAvailableStaffByService.fetch(selectedServiceCode || undefined));
      }, 1000);
    }
  };

  const handleOnClickStaff = (staff: IStaffAvailableItem) => {
    if (filterStaff?.staffId === staff.staffId) {
      setFilterStaff(undefined);
      return;
    }
    setFilterStaff(staff);
  };

  return (
    <Container>
      <div className='filter-container'>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box display='flex' alignItems='center' gap='2'>
            <Funnel strokeWidth={2.5} color={colorTheme.teal_5} size={20} />
            <Text variant='H7' textAlign='left'>
              FILTER
            </Text>
          </Box>
          <Button ntype='TERTIARY' newStyle height={3} onClick={() => configServiceCodeRef.current?.open()} iconElement={<Settings color={colorTheme.text_1} />}>
            Config Service Group
          </Button>
        </Box>
        <FilterBox>
          {ListOptionServiceCode?.map((o, index) => (
            <FilterItem
              key={index}
              label={o.label}
              onClick={() => handleClickFilterItem(o.value)}
              active={selectedServiceCode === o.value}
            />
          ))}
        </FilterBox>
      </div>
      <div className='box-container'>
        <div className='staff-turn-list-container'>
          <div className='staff-turn-list'>
            {staffs.map((o, i) => {
              return (
                <StaffTurn highlight={i === 0} index={i + 1} data={o} key={o.staffId} onClick={() => handleOnClickStaff(o)} selectedStaff={o.staffId === filterStaff?.staffId} />
              );
            })}
          </div>
        </div>
      </div>

      <div className='list-working-turn-container'>
        <Text variant='H7' textAlign='left'>
          Add Working Turn
        </Text>
        <div className='list-service'>
            {ADD_WORKING_TURN?.map((o, index) => <TurnServiceItem onClick={() => onChooseService(o)} key={index} active={o.active} noTurn={o.turn === 0} serName={o?.itemName || ''} subTurn={o.status === TURN_ITEM_STATUS.MINUS_TURN} subHalf={o.status === TURN_ITEM_STATUS.HALF_MINUS_TURN}/>)}
        </div>
      </div> 
      <div className='list-service-container'>
        <Text variant='H7' textAlign='left'>
          Add Turn Manual
        </Text>
        <div className='list-service'>
          {fullTurnData.length > 0 && fullTurnData.map(o => <TurnServiceItem onClick={() => onChooseService(o)} type='WALK_IN' key={o.itemId} full serName={o?.itemName || ''} />)}
          {halfTurnData.length > 0 && halfTurnData.map(o => <TurnServiceItem onClick={() => onChooseService(o)} key={o.itemId} half  serName={o?.itemName || ''} />)}
          {noTurnData.length > 0 && noTurnData.map(o => <TurnServiceItem onClick={() => onChooseService(o)} key={o.itemId} noTurn serName={o?.itemName || ''} />)}
        </div>
      </div>
      <MangersStyled>
        <div className='header-section' onClick={() => setOpen(!open)}>
          <MoveUp size={18} className={`arrow ${open ? 'open' : ''}`} color='#d2464f' />
          <Text variant='CONTENT_2'>Management Team</Text>
        </div>
        <div className={`staff-wrapper ${open ? 'open' : ''}`}>
          <div>
            <div className='staff-managers-list'>
              {inActiveTurnStaffs.map((o) => {
                return <StaffTurnManager data={o} key={o.staffId} />;
              })}
            </div>
          </div>
        </div>
      </MangersStyled>
      <div className='fozito-icon-container'>
        {/* <div className='fozito-icon'>
          <img src={Logo} alt='Logo' />
        </div> */}
        <TurnActions displayFilterServiceStaff={true} selectedServiceCode={selectedServiceCode} />
      </div>
      <ConfigServiceCode ref={configServiceCodeRef} />
    </Container>
  );
};

export default StaffFilterTurn;

const MangersStyled = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 600px;
  overflow: auto;
  position: relative;
  z-index: 1;
  border-left: 2px solid #ccd4dc;

  .header-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    position: sticky;
    top: 0;
    z-index: 99;
    padding: 8px 16px;
    background: #fff1f6;
    box-shadow: 0px 2px 0px 0px #ff8890;
    cursor: pointer;
    
    .CONTENT_2 {
      color: #d2464f;
      text-align: center;
    }
  }

  .arrow {
    transition: transform 0.25s ease;
  }

  .arrow.open {
    transform: rotate(180deg);
  }

  .staff-wrapper {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.28s ease;
  }

  .staff-wrapper > div {
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .staff-wrapper.open {
    grid-template-rows: 1fr;
  }

  .staff-wrapper.open > div {
    opacity: 1;
  }

  .staff-managers-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 16px;
  }
`;

const Container = styled.div`
  width: 570px;
  display: flex;
  align-self: stretch;
  flex-direction: column;
  background: #eaf9fb;

  .filter-container {
    padding: 16px;
    border-left: 2px solid #ccd4dc;
    border-bottom: 1px solid #ccd4dc;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .H7 {
      font-family: Poppins;
    }

    .CONTENT_2 {
      font-family: Poppins;
    }
  }

  .box-container {
    flex: 1;
    box-shadow: 0px -8px 16px -8px rgba(0, 0, 0, 0.15);
    border-left: 2px solid #ccd4dc;
    position: relative;
    .staff-turn-list-container {
      inset: 0;
      position: absolute;
      overflow-y: auto;
      overflow-x: hidden;
      scrollbar-width: none; /* Firefox 64 */
      &::-webkit-scrollbar {
        width: 0px;
        height: 8px;
        background-color: #f5f5f5;
      }
    }
    .staff-turn-list {
      padding: 24px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: stretch;
      gap: 8px;
    }
  }
  .fozito-icon-container {
    background: #fff;
    border: 1px solid #ccd4dc;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fozito-icon {
    width: 180px;
    height: 100px;
    padding: 4px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  @keyframes glow {
    0% {
      box-shadow: 0 0 4px #f5b945;
    }

    50% {
      box-shadow:
        0 0 12px #f5b945,
        0 0 24px #f5b945,
        0 0 36px rgba(245, 185, 69, 0.8);
    }

    100% {
      box-shadow: 0 0 4px #f5b945;
    }
  }

  .list-service-container {
    padding: 16px;
    border-left: 2px solid #ccd4dc;
    border-top: 1px solid #ccd4dc;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .list-service {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .list-working-turn-container {
    padding: 16px;
    border-left: 2px solid #ccd4dc;
    border-top: 1px solid ${colorTheme.v2_primary_bg_4};    
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: ${colorTheme.v2_primary_bg_2};
  }

  .fozito-icon-container {
    padding: 8px;
  }
`;

const FilterBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
`;

interface IFilterItemProps {
  label: string;
  onClick?: () => void;
  active?: boolean;
}

const FilterItem = ({ label, onClick, active }: IFilterItemProps) => {
  return (
    <ContentItem onClick={onClick} className={active ? 'active' : ''}>
      <Text variant='H8' textAlign='center'>
        {label}
      </Text>
    </ContentItem>
  );
};

const ContentItem = styled.div`
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid ${colorTheme.ink_2};
  cursor: pointer;
  background: ${colorTheme.text_1};

  .H8 {
    font-weight: 600;
    font-family: Poppins;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &.active {
    border: none;
    border: 1px solid ${colorTheme.coral_5};
    background: ${colorTheme.coral_5};
    .H8 {
      color: #fff;
    }
  }
`;
